import { reactPlugin } from '@datadog/browser-rum-react';
import { datadogRum } from '@datadog/browser-rum';
import { WHITE_LIST_DD_ENV } from '@src/constants/datadog';
import {
  DATADOG_APPLICATION_ID,
  DATADOG_CLIENT_TOKEN,
  DATADOG_SITE,
  DATADOG_SERVICE,
  ENV,
} from '../configs';

let isInitialized = false;

export function initDatadogRum({
  reactPluginEnabled,
  reactPluginRouter,
  sessionSampleRate,
  sessionReplaySampleRate,
  defaultPrivacyLevel,
  trackUserInteractions,
  trackResources,
  trackLongTasks,
}) {
  if (isInitialized) {
    return;
  }
  if (
    !DATADOG_APPLICATION_ID ||
    !DATADOG_CLIENT_TOKEN ||
    !DATADOG_SITE ||
    !WHITE_LIST_DD_ENV.includes(ENV)
  ) {
    return;
  }
  const plugins = [];
  if (reactPluginEnabled) {
    plugins.push(reactPlugin({ router: !!reactPluginRouter }));
  }

  datadogRum.init({
    applicationId: DATADOG_APPLICATION_ID,
    clientToken: DATADOG_CLIENT_TOKEN,
    site: DATADOG_SITE,
    service: DATADOG_SERVICE,
    env: ENV,
    sessionSampleRate,
    sessionReplaySampleRate,
    defaultPrivacyLevel,
    trackUserInteractions,
    trackResources,
    trackLongTasks,
    plugins,
  });
  datadogRum.startView();
  datadogRum.startSessionReplayRecording();
  isInitialized = true;
}

export function setDatadogUser({ id, email, username } = {}) {
  datadogRum.setUser({ id, email, username });
}

export function clearDatadogUser() {
  datadogRum.clearUser();
}
